import { useState } from 'react';
import { Alert, Button, Group, Text } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/auth';

const DISMISS_KEY = 'customer-sso-setup-banner-dismissed';

/**
 * Admin-Hinweis: Kundenportal-SSO ist noch nicht eingerichtet.
 * Sichtbar für ADMIN/TEAMLEAD, solange weder Microsoft noch Google fürs
 * Kundenportal konfiguriert ist. Führt direkt zum Settings-Tab mit dem
 * Auto-Setup (Entra-App per Klick anlegen). Pro Browser-Session wegklickbar.
 */
export function CustomerSsoSetupBanner() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const canSetup = user?.role === 'ADMIN' || user?.role === 'TEAMLEAD';
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1'
  );

  const { data } = useQuery({
    queryKey: ['customer-sso-setup-status'],
    queryFn: () => api.getCustomerSsoSetupStatus(),
    enabled: canSetup && !dismissed,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (!canSetup || dismissed || !data) return null;
  if (data.microsoftConfigured || data.googleConfigured) return null;

  return (
    <Alert
      color="orange"
      radius="md"
      mb="md"
      icon={<IconUsers size={18} />}
      withCloseButton
      onClose={() => {
        sessionStorage.setItem(DISMISS_KEY, '1');
        setDismissed(true);
      }}
      title="Kundenportal-SSO noch nicht eingerichtet"
    >
      <Group justify="space-between" wrap="wrap" gap="sm">
        <Text size="sm" maw={560}>
          Kunden können sich bisher nur per E-Mail-Link anmelden. Richte Microsoft-/Google-Login
          ein — die Entra-App lässt sich dabei automatisch anlegen (Auto-Setup, ~2 Minuten).
        </Text>
        <Button
          size="xs"
          color="orange"
          onClick={() => navigate('/admin/settings?tab=customer_sso')}
        >
          Jetzt einrichten
        </Button>
      </Group>
    </Alert>
  );
}
